(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const cartDrawer = document.querySelector('[data-component="cart-drawer"]');
    const cartDrawerData = cartDrawer ? JSON.parse(cartDrawer.querySelector('[data-component-data]').innerHTML) : null;
    const isCartDrawerEnabled = cartDrawerData && cartDrawerData.enabled;

    // Only prevent cart navigation if cart drawer is enabled (cart_type == 'drawer')
    if (isCartDrawerEnabled) {
      document.addEventListener('product-form:cart:navigate', function(event) {
        event.preventDefault();
      });
    }

    document.addEventListener('product-form:submit:success', function(event) {
      const { cart, response } = event.detail;
      
      // Dispatch the product:add-to-cart:success event that the Product class listens for
      document.dispatchEvent(new CustomEvent('product:add-to-cart:success', {
        bubbles: true,
        detail: { cart, line_item: response }
      }));

      // Open cart drawer
      if (isCartDrawerEnabled) {
        const cartDrawerComponent = window.Core.Components.getComponent('cart-drawer');
        const submitButton = document.querySelector('product-form button[type="submit"]');
        cartDrawerComponent.open(submitButton, true, [response]);
      }
    });

    document.addEventListener('product-form:cart:update', function(event) {
      // Dispatch cart:update event to update header cart count
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { count: event.detail.cart.item_count }
      }));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faq-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const faqTriggers = document.querySelectorAll('.faq-trigger');

    faqTriggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const panel = this.nextElementSibling;

        document.querySelectorAll('.faq-trigger').forEach(otherTrigger => {
          if (otherTrigger !== trigger && otherTrigger.getAttribute('aria-expanded') === 'true') {
            otherTrigger.setAttribute('aria-expanded', 'false');
            otherTrigger.nextElementSibling.style.maxHeight = null;
          }
        });

        // Перемикаємо поточний елемент
        if (isExpanded) {
          this.setAttribute('aria-expanded', 'false');
          panel.style.maxHeight = null;
        } else {
          this.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
